// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b8687616","453":"602e1eae","455":"272d893d"}[chunkId] + ".chunk.js";
};